import styled from 'styled-components'

import colors from 'styles/colors'

interface IStatusProps {
    $isOpen?: boolean
}

export const StyledStatus = styled.span<IStatusProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;
    padding: 0.2rem 0.3rem;

    border-radius: 0.5rem;
    color: ${props => (props.$isOpen ? colors.green : colors.grey)};
    background-color: ${props =>
        props.$isOpen ? colors.greenLight : colors.whiteSmoke};

    font-size: 1rem;
    letter-spacing: 0.02em;
    font-weight: 600;
    text-transform: capitalize;

    margin-right: 2rem;
`

export const StyledLabelNew = styled.span`
    background-color: ${colors.blueLight};
    border-radius: 0.5rem;
    color: ${colors.white};
    display: block;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    height: 1.6rem;
    margin-left: 1rem;
    letter-spacing: 0.02em;
    text-align: center;
    width: 3rem;
`

export const StyledDateText = styled.span`
    color: ${colors.ashGray};
`

export const StyledDateDate = styled.span`
    color: ${colors.blueDark};
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.5rem;
    letter-spacing: 0.02em;
    margin-left: 0.4rem;
`

export const StyledBottomArea = styled.div`
    display: flex;
    flex-direction: column;
`

export const StyledBottomAreaText = styled.p`
    color: ${colors.slateBlueGray};
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.7rem;
    letter-spacing: 0.02em;
    margin: 2.5rem 0;
`

export const StyledBottomAreaBorder = styled.div`
    background-color: ${colors.platinumGray};
    height: 0.1rem;
    margin-bottom: 2rem;
`

export const StyledBottomAreaDetails = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`

export const StyledBottomAreaDetailsLeft = styled.div`
    align-items: center;
    display: flex;
`

export const StyledAttachInfo = styled.div`
    align-items: center;
    display: flex;
    margin-right: 1rem;
`

export const StyledAttachText = styled.span`
    color: ${colors.grey};
    display: block;
    font-weight: 500;
    margin-left: 0.3rem;
`

export const StyledMessageInfo = styled.div`
    align-items: center;
    color: ${colors.blueLight};
    display: flex;
    margin-right: 1rem;
`

export const StyledMessageText = styled.span`
    color: ${colors.grey};
    font-weight: 500;
    margin-left: 0.3rem;
`

export const StyledBottomAreaDetailsRight = styled.div`
    align-items: center;
    display: flex;
    margin-left: auto;
`
export const StyledTicketIdInfo = styled.span`
    color: ${colors.grey};
    font-size: 1.2rem;
    font-weight: 600;
    margin-right: 2rem;
`

export const StyledTicketIdText = styled.span`
    color: ${colors.grey};
    font-weight: 400;
    margin-right: 0.4rem;
`

export const StyledAttachImage = styled.img`
    width: 5rem;
    &:not(:last-child) {
        margin-right: 0.5rem;
    }
`

export const StyledAttachmentsWrapper = styled.div`
    display: flex;
`
